import { type UserSearchItem } from '@atlaskit/smart-common';
import { type QuickFindAllActivityDataEdge, type SearchPageNode } from '@atlassian/search-client';

type ErrorContent = {
	id: string;
	type: 'error';
};

export const isErrorContent = (content: Content): content is ErrorContent => {
	return content.type === 'error';
};

type LandingContent = {
	id: string;
	type: 'landing';
};

export const isLandingContent = (content: Content): content is LandingContent => {
	return content.type === 'landing';
};

type NoResultsContent = {
	id: string;
	type: 'no-results';
};

export const isNoResultsContent = (content: Content): content is NoResultsContent => {
	return content.type === 'no-results';
};

type HeadingContent = {
	id: string;
	type: 'heading';
	data: string;
	includeInAnalytics?: boolean;
};

export const isHeadingContent = (content: Content): content is HeadingContent => {
	return content.type === 'heading';
};

type SkeletonContent = {
	id: string;
	type: 'skeleton';
};

export const isSkeletonContent = (content: Content): content is SkeletonContent => {
	return content.type === 'skeleton';
};

type RecentQueryContent = {
	id: string;
	type: 'recent-query';
	data: string;
};

export const isRecentQueryContent = (content: Content): content is RecentQueryContent => {
	return content.type === 'recent-query';
};

type RecentActivityContent = {
	id: string;
	type: 'recent-activity';
	data: QuickFindAllActivityDataEdge;
};

export const isRecentActivityContent = (content: Content): content is RecentActivityContent => {
	return content.type === 'recent-activity';
};

type SearchResultContent = {
	id: string;
	type: 'search-result';
	data: SearchPageNode;
};

export const isSearchResultContent = (content: Content): content is SearchResultContent => {
	return content.type === 'search-result';
};

type PeopleAndTeamsContent = {
	id: string;
	type: 'people-and-teams';
	data: UserSearchItem;
};

export const isPeopleAndTeamsContent = (content: Content): content is PeopleAndTeamsContent => {
	return content.type === 'people-and-teams';
};

export type Content =
	| ErrorContent
	| LandingContent
	| NoResultsContent
	| HeadingContent
	| SkeletonContent
	| RecentQueryContent
	| RecentActivityContent
	| SearchResultContent
	| PeopleAndTeamsContent;
